import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectSort = (store: StoreSchema) =>
	store.licenseEvents.sort.sort
